import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import type { CompetitorSourceName } from '~/types/services/priceParrot';

import { competitorOffersQueryKeys } from './competitorOffersQueryKeys';

export function useGetCompetitorPropertyHistory(sourceName: CompetitorSourceName, externalPropertyId: string) {
  return useQuery({
    queryKey: competitorOffersQueryKeys.history(sourceName, externalPropertyId),
    queryFn: async ({ signal }) =>
      (await PriceParrotService.getCompetitorPropertyHistory(sourceName, externalPropertyId, signal)).data,
  });
}
